<media-item-header></media-item-header>

<ad-host slot="ads.shared" class="shared-ad-host"></ad-host>

<div class="container">
    <router-outlet></router-outlet>
</div>

<footer></footer>
